// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"37ac4ddce74fe5f4","5285":"9fc921a7c2d4320c"}[chunkId] + ".css";
};